// @flow
import React from 'react';
import Header from '../Header/header';

type Props = {
  children: React$Node,
}

const Container = ({ children }: Props) => (
  <>
    <Header />
    { children }
  </>
);
export default Container;
